/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IReferencias from 'Infotrack@Modelos/smartStock/referencias/entidades/referencias';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import ReferenciasCM from '../controladorModelo/referenciasCM';
import { IFormularioReferenciasCVProps } from '../interfaces';
import { acciones, IEstadoReferencias } from '../reductorReferencias';
import FormularioReferenciasVista from '../vista/formularioReferenciasVista';
import { useSelector } from 'react-redux';

const estadoInicial: IReferencias = {
    EmpresaId: '',
    ReferenciaDescripcion: '',
    Estado: 1,
    AgenciaId: '',
};
const referenciasCM = new ReferenciasCM();

const FormularioReferenciasCV: React.FunctionComponent<IFormularioReferenciasCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadReferencias }, dispatch] = useProveedor<IEstadoReferencias>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IReferencias>(estadoInicial);

    React.useEffect(() => {
        if (entidadReferencias && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadReferencias);
        } else {
            reiniciar();
        }
    }, [entidadReferencias]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionReferencias = () => {
        if (referenciasCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarReferencias,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarReferencias = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            referenciasCM
                .crearReferencias({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            referenciasCM
                .editarReferencias({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioReferenciasVista
            accionCrearEditar={confirmarCreacionEdicionReferencias}
            cambiarInfoFomulario={alCambiarValor}
            referencias={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioReferenciasCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
});

export default connect<IFormularioReferenciasCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioReferenciasCV);
